<template>
    <div class="tabs-container">
        <DxTabs :data-source="tabs" :selected-index.sync="selectedIndex" @option-changed="onTabChanged" orientation="vertical" 
            :item-template="tabTemplate" class="tabs"/>
        <div v-if="selectedIndex===0" class="tab-content">
            <GridGrupuriAngajati/>
        </div>
        <div v-if="selectedIndex===1" class="tab-content">
            <GridMeserii/>
        </div>
        <div v-if="selectedIndex===2" class="tab-content">
            <GridPositions/>
        </div>
        <div v-if="selectedIndex===3" class="tab-content">
            <GridSarbatoriLegale/>
        </div>
        <div v-if="selectedIndex===4" class="tab-content">
            <GridTemeiuriLegale/>
        </div>
        <div v-if="selectedIndex===5" class="tab-content">
            <GridTrepteDeVechime/>
        </div>
        <div v-if="selectedIndex===6" class="tab-content">
            <GridIndemnizatii/>
        </div>
        <div v-if="selectedIndex===7" class="tab-content">
            <GridTipRetinere/>
        </div>
        <div v-if="selectedIndex===8" class="tab-content">
            <GridStudies/>
        </div>
        <div v-if="selectedIndex===9" class="tab-content">
            <GridTipuriDocIdentitate/>
        </div>
        <div v-if="selectedIndex===10" class="tab-content">
            <GridTipuriConcedii/>
        </div>
        <div v-if="selectedIndex===11" class="tab-content">
            <GridAtribute/>
        </div>
        <div v-if="selectedIndex===12" class="tab-content">
            <GridMomenteCalcul/>
        </div>
        <div v-if="selectedIndex===13" class="tab-content">
            <GridActivitati/>
        </div>
        <div v-if="selectedIndex===14" class="tab-content">
            <GridCerinte/>
        </div>
        <div v-if="selectedIndex===15" class="tab-content">
            <GridGrilaSalarizare/>
        </div>
        <div v-if="selectedIndex===16" class="tab-content">
            <GridStariPosturi/>
        </div>
        <!-- Portal HR Admin -->
        <div v-if="selectedIndex===17" class="tab-content">
            <TipuriCereriDocumente/>
        </div>
        <div v-if="selectedIndex===18" class="tab-content">
            <TipuriDocumenteHR/>
        </div>
        <div v-if="selectedIndex===19" class="tab-content">
            <AprobariPortalHR/>
        </div>
    </div>
</template>
<script lang="ts">
    import { DxTabs } from 'devextreme-vue/tabs';
    import GridMeserii from './GridMeserii.vue';
    import GridStudies from './GridStudies.vue';
    import GridSarbatoriLegale from './GridSarbatoriLegale.vue';
    import GridPositions from './GridPositions.vue';
    import GridGrupuriAngajati from './GridGrupuriAngajati.vue';
    import GridStariPosturi from './GridStariPosturi.vue';
    import GridTipuriConcedii from './GridTipuriConcedii.vue';
    import GridTemeiuriLegale from './GridTemeiuriLegale.vue';
    import GridTipuriDocIdentitate from './GridTipuriDocIdentitate.vue';
    import GridTrepteDeVechime from './GridTrepteDeVechime.vue';
    import GridIndemnizatii from './GridIndemnizatii.vue';
    import GridActivitati from './GridActivitati.vue';
    import GridTipRetinere from './GridTipRetinere.vue';
    import GridAtribute from './GridAtribute.vue';
    import GridCerinte from './GridCerinte.vue';
    import GridGrilaSalarizare from './GridGrilaSalarizare.vue';
    import GridMomenteCalcul from './GridMomenteCalcul.vue';
    import TipuriCereriDocumente from './Admin/TipuriCereriDocumente.vue';
    import TipuriDocumenteHR from './Admin/TipuriDocumenteHR.vue';
    import AprobariPortalHR from './Admin/AprobariPortalHR.vue';

    export default {
        components: {
            DxTabs,
            GridMeserii,
            GridStudies,
            GridSarbatoriLegale,
            GridPositions,
            GridGrupuriAngajati,
            GridStariPosturi,
            GridTipuriConcedii,
            GridTemeiuriLegale,
            GridTipuriDocIdentitate,
            GridTrepteDeVechime,
            GridIndemnizatii,
            GridActivitati,
            GridTipRetinere,
            GridAtribute,
            GridCerinte,
            GridGrilaSalarizare,
            GridMomenteCalcul,
            TipuriCereriDocumente,
            TipuriDocumenteHR,
            AprobariPortalHR
        },
        data() {
            return {
                tabs: [
                    { text: 'Grupuri Angajati'},
                    { text: 'Meserii' },
                    { text: 'Functii' },
                    { text: 'Sarbatori Legale' },
                    { text: 'Temeiuri legale' },
                    { text: 'Trepte de Vechime' },
                    { text: 'Indemnizatii CM' },
                    { text: 'Tipuri Retineri' },
                    { text: 'Studii' },
                    { text: 'Tipuri Doc. Identitate' },
                    { text: 'Tipuri Concedii' },
                    { text: 'Atribute' },
                    { text: 'Momente Calcul Salarii' },
                    { text: 'Activitati' },
                    { text: 'Cerinte' },
                    { text: 'Grile Salarizare' },
                    { text: 'Stari Posturi' },
                    // Portal HR Admin
                    { text: '--- Portal HR ---' },
                    { text: 'Tipuri Cereri Doc.' },
                    { text: 'Tipuri Doc. HR' },
                    { text: 'Aprobări Portal HR' },
                ],
                selectedIndex: 0,
            }
        },
        methods: {
            onTabChanged(e: any) {
                this.selectedIndex = e.component.option('selectedIndex');

                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        subTab: this.selectedIndex
                    }
                }).catch(()=>{})
            },
            tabTemplate(itemData, itemIndex, itemElement) {
                return  `<div>${itemData.text}</div>`;
            },
        },
        mounted() {
            if (this.$route.query.subTab) {
                this.selectedIndex = Number(this.$route.query.subTab);
            }
        }
    }
</script>
<style scoped>
.tabs-container {
    display: flex; 
    flex-direction: row; 
    width: 100%;
}

.tabs {
    width: 250px; 
    flex-shrink: 0; 
}

.tab-content {
    flex-grow: 1; 
    padding: 0 20px; 
    overflow: auto; 
}
</style>
